import styled, { css } from 'styled-components';
import Colors from '../../tokens/Colors';
import Text from '../../atoms/Text';

const Tag = ({ children, ...props }) => (
    <TagStyled {...props}>
        <Text title size="32">
            {children}
        </Text>
    </TagStyled>
);

const TagStyled = styled.div`
    padding: 4px 8px;
    display: inline-block;
    background-color: ${props => props.bg ?? Colors.lightGrey};
    color: ${props => props.color ?? Colors.black};

    ${props =>
        props.nowrap &&
        css`
            @media (max-width: 768px) {
                white-space: nowrap;
            }
        `}

    ${props =>
        props.primary &&
        css`
            background-color: ${Colors.primary};
            color: ${Colors.black};
        `}

    ${props =>
        props.education &&
        css`
            background-color: ${props.bg ?? Colors.educationGreen};
            color: ${props.color ?? Colors.black};
        `}

    ${props =>
        props.dark &&
        css`
            background-color: ${Colors.black};
            color: ${Colors.white};
        `}

    ${props =>
        props.light &&
        css`
            background-color: ${Colors.white};
            color: ${Colors.black};
        `}

		${props =>
        props.false &&
        css`
            background: none;
            border: 1px solid ${Colors.red};
            color: ${Colors.red};
            text-align: center;
            width: 100%;
        `}

		${props =>
        props.true &&
        css`
            background: none;
            border: 1px solid ${Colors.green};
            color: ${Colors.green};
            text-align: center;
            width: 100%;
        `}

		${props =>
        props.exaggerated &&
        css`
            background: none;
            border: 1px solid ${Colors.orange};
            color: ${Colors.orange};
            text-align: center;
            width: 100%;
        `}

		${props =>
        props.underrated &&
        css`
            background: none;
            border: 1px solid ${Colors.yellow};
            color: ${Colors.yellow};
            text-align: center;
            width: 100%;
        `}

		${props =>
        props.true_but &&
        css`
            background: none;
            border: 1px solid ${Colors.blue};
            color: ${Colors.blue};
            text-align: center;
            width: 100%;
        `}

		${props =>
        props.unsustainable &&
        css`
            background: none;
            border: 1px solid ${Colors.purple};
            color: ${Colors.purple};
            text-align: center;
            width: 100%;
        `}

		${props =>
        props.early &&
        css`
            background: none;
            border: 1px solid ${Colors.pink};
            color: ${Colors.pink};
            text-align: center;
            width: 100%;
        `}

		${props =>
        props.contradictory &&
        css`
            background: none;
            border: 1px solid ${Colors.brown};
            color: ${Colors.brown};
            text-align: center;
            width: 100%;
        `}

		${props =>
        props.watchful &&
        css`
            background: none;
            border: 1px solid ${Colors.beige};
            color: ${Colors.beige};
            text-align: center;
            width: 100%;
        `}

        ${props =>
            props.without_context &&
            css`
                background: none;
                border: 1px solid ${Colors.darkPink};
                color: ${Colors.darkPink};
                text-align: center;
                width: 100%;
            `}
`;

export default Tag;
